import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XIcon } from 'lucide-react';
export function FailedSolutions() {
  const failures = ['Las aplicaciones de presupuesto tradicionales requieren un mantenimiento diario que aburre a tu cerebro en 3 días.', 'Las hojas de Excel son estáticas, frías y no te avisan cuando el peligro se acerca.', 'Los consejos de "ahorro" genéricos no entienden que tu impulsividad es una respuesta biológica, no un defecto de carácter.', 'Intentar "esforzarte más" solo te lleva al agotamiento, porque la voluntad no puede sustituir a un sistema deficiente.'];
  return <section className="py-20 bg-brand-cream" data-id="element-13">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-14">
        <FadeIn data-id="element-15">
          <div className="text-center mb-12" data-id="element-16">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-teal mb-4" data-id="element-17">
              Por qué lo que has intentado no funcionó
            </h2>
            <div className="w-16 h-[1px] bg-brand-gold mx-auto" data-id="element-18"></div>
          </div>
        </FadeIn>

        <div className="grid gap-6" data-id="element-19">
          {failures.map((text, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-20">
              <div className="flex items-start p-6 bg-white rounded-xl shadow-sm border border-brand-teal/5" data-id="element-21">
                <div className="flex-shrink-0 mt-1" data-id="element-22">
                  <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center" data-id="element-23">
                    <XIcon className="w-5 h-5 text-red-400" data-id="element-24" />
                  </div>
                </div>
                <p className="ml-4 text-lg text-brand-charcoal/80" data-id="element-25">{text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}